exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".admin-table-vendor-purchase-width .admin-table-row td:nth-child(3){padding-left:0!important}.admin-table-vendor-purchase-width .admin-table-row td:nth-child(3)>div span:last-child{padding-left:5px!important}#comment{width:-webkit-fill-available}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/views/VendorPurchaseAdmin/VendorPurchaseAdmin.scss
 ** module id = 305
 ** module chunks = 0
 **/